import React, { useEffect, useRef, useState } from "react";

import {
    Box,
    Typography,
    Container,
    Button,
    Modal,
    IconButton,
    Divider,
    useMediaQuery,
    Stack,
} from "@mui/material";

import { gsap } from "gsap";

import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded";

import { Tribuja } from "../../assets";

// ================= FLOOR PLAN DATA =================

const floorPlansData = [
    {
        id: 1,
        bhk: "3BHK",
        size: "1677",
        facing: "west Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%205%20West%20Facing%201677%20Sq.%20Ft.png",
    },

    {
        id: 2,
        bhk: "3BHK",
        size: "1679",
        facing: "West Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%205%20West%20Facing%201679%20Sq.%20Ft.png",
    },

    {
        id: 3,
        bhk: "3BHK",
        size: "1693",
        facing: "East Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%202%20East%20Facing%201693%20Sq.%20Ft%20(2).png",
    },

    {
        id: 4,
        bhk: "3BHK",
        size: "2096",
        facing: "west Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%206%20West%20Facing%202096%20Sq.%20Ft.png",
    },

    {
        id: 5,
        bhk: "3BHK",
        size: "2112",
        facing: "East Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%201%20East%20Facing%202112%20Sq.%20Ft.png",
    },
    {
        id: 6,
        bhk: "3BHK",
        size: "2289",
        facing: "West Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%204%20West%20Facing%202289%20Sq.%20Ft.png",
    },
    {
        id: 7,
        bhk: "3BHK",
        size: "2314",
        facing: "east Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/3%20BHK%2C%20Unit%202%20East%20Facing%202314%20Sq.%20Ft.png",
    },
    {
        id: 8,
        bhk: "4BHK",
        size: "3125",
        facing: "east Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/4%20BHK%2C%20Unit%202%20East%20Facing%203125%20Sq.%20Ft.png",
    },
    {
        id: 9,
        bhk: "4BHK",
        size: "3126",
        facing: "west Facing",
        image:
            "https://dprstorage.b-cdn.net/RW/tribuja/4%20BHK%2C%20Unit%204%20West%20Facing%203126%20Sq.%20Ft.png",
    },
];

interface FloorPlansProps {
    title?: string;
}

const LuxuryFloorPlans: React.FC<FloorPlansProps> = ({ title }) => {
    const imageRef = useRef<HTMLDivElement | null>(null);

    const isMobile = useMediaQuery("(max-width:900px)");

    const [selectedPlan, setSelectedPlan] = useState(floorPlansData[0]);

    const [openModal, setOpenModal] = useState(false);


    const [scrollIndex, setScrollIndex] = useState(0);

    const visibleTabs = isMobile ? 2 : 6;

    const handleTabScroll = (
        direction: "prev" | "next"
    ) => {
        if (direction === "next") {
            if (
                scrollIndex <
                floorPlansData.length - visibleTabs
            ) {
                setScrollIndex(scrollIndex + 1);
            }
        } else {
            if (scrollIndex > 0) {
                setScrollIndex(scrollIndex - 1);
            }
        }
    };

    // ================= GSAP =================

    useEffect(() => {
        if (imageRef.current) {
            gsap.fromTo(
                imageRef.current,
                {
                    opacity: 0,
                    y: 40,
                },
                {
                    opacity: 1,
                    y: 0,
                    duration: 1,
                    ease: "power3.out",
                }
            );
        }
    }, [selectedPlan]);

    // ================= NEXT PREV =================


    return (
        <Box
            sx={{
                position: "relative",

                width: "100%",

                overflow: "hidden",

                backgroundImage: `url("https://dprstorage.b-cdn.net/RW/leadgen/herobg2.webp")`,

                backgroundSize: "cover",

                backgroundPosition: "center",

                py: { xs: 8, md: 4 },

                "&::after": {
                    content: '""',

                    position: "absolute",

                    inset: 0,

                    background:
                        "linear-gradient(to bottom, rgba(0,0,0,0.62), rgba(0,0,0,0.62))",

                    zIndex: 1,
                },
            }}
        >
            <Container
                maxWidth="xl"
                sx={{
                    position: "relative",
                    zIndex: 2,
                }}
            >
                {/* ================= TITLE ================= */}

                <Box textAlign="center" mb={3}>
                    <Typography
                        variant="h4"
                        
                        sx={{

                            fontFamily: "Luxury",
                            fontWeight: 500,

                            color: "#fff",

                            letterSpacing: "1px",

                            textTransform: "uppercase",

                            mb: 2,
                        }}
                    >
                        Floor Plans
                    </Typography>
                    <Box
                        sx={{
                            width: {
                                xs: "120px",
                                md: "180px",
                            },

                            height: "2px",

                            background:
                                "linear-gradient(to right, transparent, #fff, transparent)",

                            mx: "auto",

                            mb: 3,
                        }}
                    />


                </Box>


                {/* ================= SFT BUTTONS ================= */}
                {/* ================= SFT BUTTONS ================= */}

                <Box
                    sx={{
                        display: "flex",

                        alignItems: "center",

                        justifyContent: "center",

                        width: "100%",

                        mb: 2,


                    }}
                >
                    {/* LEFT ARROW */}

                    <IconButton
                        onClick={() => handleTabScroll("prev")}
                        sx={{
                            width: 46,

                            height: 46,

                            flexShrink: 0,

                            background: "rgba(255,255,255,0.06)",

                            border:
                                "1px solid rgba(255,255,255,0.12)",

                            color: "white",

                            backdropFilter: "blur(10px)",

                            mr: 2,

                            transition: "0.4s",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg,#30779d,silver)",

                                transform: "translateX(-3px)",
                            },
                        }}
                    >
                        <ArrowBackIosNewRoundedIcon
                            sx={{
                                fontSize: 18,
                            }}
                        />
                    </IconButton>

                    {/* TABS WRAPPER */}
                    {/* TABS WRAPPER */}

                    <Box
                        sx={{
                            width: {
                                xs: "72%",
                                md: "84%",
                            },

                            overflow: "hidden",

                            position: "relative",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",

                                gap: 2,

                                transform: {
                                    xs: `translateX(-${scrollIndex * 145
                                        }px)`,

                                    md: `translateX(-${scrollIndex * 175
                                        }px)`,
                                },

                                transition: "0.5s ease",
                            }}
                        >
                            {floorPlansData.map((plan) => {
                                const active =
                                    selectedPlan.id === plan.id;

                                return (
                                    <Box
                                        key={plan.id}
                                        sx={{
                                            position: "relative",

                                            flexShrink: 0,
                                        }}
                                    >
                                        <Button
                                            onClick={() =>
                                                setSelectedPlan(plan)
                                            }
                                            sx={{
                                                fontFamily: "PoetsenOne",
                                                minWidth: {
                                                    xs: "130px",
                                                    md: "160px",
                                                },

                                                height: "40px",

                                                borderRadius: "50px",

                                                border: active
                                                    ? "1px solid silver"
                                                    : "1px solid rgba(255,255,255,0.12)",

                                                background: active
                                                    ? "linear-gradient(135deg,#30779d,silver)"
                                                    : "rgba(255,255,255,0.06)",

                                                color: "white",

                                                backdropFilter:
                                                    "blur(10px)",

                                                fontWeight: 400,

                                                letterSpacing: 1,

                                                whiteSpace: "nowrap",

                                                transition: "0.4s",

                                                boxShadow: active
                                                    ? "0px 10px 35px rgba(48,119,157,0.4)"
                                                    : "none",

                                                "&:hover": {
                                                    background:
                                                        "linear-gradient(135deg,#30779d,silver)",
                                                },
                                            }}
                                        >
                                            {plan.size} - SQ.FT
                                        </Button>

                                        {/* ACTIVE TAB ARROW */}

                                        {active && (
                                            <Box
                                                sx={{
                                                    position: "absolute",

                                                    left: "50%",

                                                    transform:
                                                        "translateX(-50%)",

                                                    bottom: "-12px",

                                                    width: 0,

                                                    height: 0,

                                                    borderLeft:
                                                        "10px solid transparent",

                                                    borderRight:
                                                        "10px solid transparent",

                                                    borderTop:
                                                        "12px solid #30779d",
                                                }}
                                            />
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    </Box>

                    {/* RIGHT ARROW */}

                    <IconButton
                        onClick={() =>
                            handleTabScroll("next")
                        }
                        sx={{
                            width: 46,

                            height: 46,

                            flexShrink: 0,

                            background:
                                "rgba(255,255,255,0.06)",

                            border:
                                "1px solid rgba(255,255,255,0.12)",

                            color: "white",

                            backdropFilter: "blur(10px)",

                            ml: 2,

                            transition: "0.4s",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg,#30779d,silver)",
                            },
                        }}
                    >
                        <ArrowForwardIosRoundedIcon
                            sx={{
                                fontSize: 18,
                            }}
                        />
                    </IconButton>
                </Box>

                {/* ================= FACING ================= */}

                <Box
                    sx={{
                        display: "flex",

                        justifyContent: "center",

                        mb: 3,
                    }}
                >
                    <Typography
                        sx={{
                            color: "white",

                            fontSize: { xs: "14px", md: "17px" },

                            px: 4,

                            py: 1,

                            borderRadius: "40px",

                            background:
                                "linear-gradient(135deg,#30779d,silver)",

                            letterSpacing: 2,

                            fontWeight: 500,

                            boxShadow: "0px 0px 25px rgba(15,99,165,0.4)",
                            fontFamily: "PoetsenOne",
                        }}
                    >
                        {selectedPlan.facing}
                    </Typography>
                </Box>

                {/* ================= IMAGE SECTION ================= */}

                <Box
                    ref={imageRef}
                    sx={{
                        position: "relative",

                        maxWidth: "900px",

                        mx: "auto",
                    }}
                >
                    {/* LEFT ARROW */}

                    {/* <IconButton
            onClick={() => handleTabScroll("prev")}
            sx={{
              position: "absolute",

              left: { xs: "-5px", md: "-30px" },

              top: "50%",

              transform: "translateY(-50%)",

              zIndex: 5,

              background: "rgba(255,255,255,0.08)",

              color: "white",

              border: "1px solid rgba(255,255,255,0.12)",

              "&:hover": {
                background: "#0f63a5",
              },
            }}
          >
            <ArrowBackIosNewRoundedIcon />
          </IconButton> */}

                    {/* RIGHT ARROW */}

                    {/* <IconButton
                onClick={() =>
              handleTabScroll("next")
            }
            sx={{
              position: "absolute",

              right: { xs: "-5px", md: "-30px" },

              top: "50%",

              transform: "translateY(-50%)",

              zIndex: 5,

              background: "rgba(255,255,255,0.08)",

              color: "white",

              border: "1px solid rgba(255,255,255,0.12)",

              "&:hover": {
                background: "#0f63a5",
              },
            }}
          >
            <ArrowForwardIosRoundedIcon />
          </IconButton> */}

                    {/* IMAGE CARD */}

                    <Box
                        sx={{
                            borderRadius: "30px",

                            overflow: "hidden",

                            background: "rgba(255,255,255,0.05)",

                            border: "1px solid rgba(255,255,255,0.08)",

                            backdropFilter: "blur(18px)",

                            p: { xs: 2, md: 2 },

                            boxShadow: "0px 20px 60px rgba(0,0,0,0.45)",
                        }}
                    >
                        {/* IMAGE */}

                        <Box
                            component="img"
                            src={selectedPlan.image}
                            alt="floor-plan"
                            onClick={() => setOpenModal(true)}
                            sx={{
                                width: "100%",

                                height: { xs: "280px", md: "400px" },

                                objectFit: "contain",

                                borderRadius: "20px",

                                // background: "#fff",

                                cursor: "pointer",

                                transition: "0.4s",

                                "&:hover": {
                                    transform: "scale(1.01)",
                                },
                            }}
                        />
                    </Box>
                </Box>

                {/* ================= MODAL ================= */}

                <Modal
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                >
                    <Box
                        sx={{
                            position: "fixed",

                            inset: 0,

                            width: "100%",

                            height: "100vh",

                            background: "rgba(0,0,0,0.96)",

                            display: "flex",

                            justifyContent: "center",

                            alignItems: "center",

                            overflow: "auto",

                            zIndex: 9999,

                            p: {
                                xs: 1,
                                md: 3,
                            },
                        }}
                    >
                        {/* CLOSE BUTTON */}

                        <IconButton
                            onClick={() => setOpenModal(false)}
                            sx={{
                                position: "fixed",

                                top: {
                                    xs: 10,
                                    md: 25,
                                },

                                right: {
                                    xs: 10,
                                    md: 25,
                                },

                                width: 42,

                                height: 42,

                                color: "#fff",

                                zIndex: 10000,

                                background: "rgba(255,255,255,0.08)",

                                border: "1px solid rgba(255,255,255,0.12)",

                                backdropFilter: "blur(10px)",

                                "&:hover": {
                                    background: "#0f63a5",
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {/* CENTER WRAPPER */}

                        <Box
                            sx={{
                                width: "100%",

                                minHeight: "100%",

                                display: "flex",

                                justifyContent: "center",

                                alignItems: "center",
                            }}
                        >
                            {/* IMAGE */}

                            <Box
                                component="img"
                                src={selectedPlan.image}
                                alt="floor-plan"
                                sx={{
                                    display: "block",

                                    width: {
                                        xs: "100%",
                                        sm: "90%",
                                        md: "auto",
                                    },

                                    height: "auto",

                                    maxWidth: {
                                        xs: "100%",
                                        md: "95%",
                                    },

                                    maxHeight: {
                                        xs: "none",
                                        md: "80vh",
                                    },

                                    objectFit: "contain",

                                    background: "#fff",

                                    borderRadius: {
                                        xs: "12px",
                                        md: "24px",
                                    },

                                    p: {
                                        xs: 1,
                                        md: 2,
                                    },

                                    boxShadow:
                                        "0px 20px 60px rgba(0,0,0,0.6)",
                                }}
                            />
                        </Box>
                    </Box>
                </Modal>
            </Container>
        </Box>
    );
};

export default LuxuryFloorPlans;